import { render, staticRenderFns } from "./invoicehead.vue?vue&type=template&id=bc22c4d8&"
import script from "./invoicehead.vue?vue&type=script&lang=js&"
export * from "./invoicehead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports